module.exports = __webpack_public_path__ + "frontend/images/homepage/carousel/mobile/2.png?a56128c0e76bce8dd2a066433b4244df";